import { render, staticRenderFns } from "./FilesWithDate.vue?vue&type=template&id=78bd287c"
import script from "./FilesWithDate.vue?vue&type=script&lang=js"
export * from "./FilesWithDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports